import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  AppState,
  ContractType,
  FilterState,
  RangeSliderOption,
  UsageSpaceFilterState,
  UsageSpaceRange,
} from '@immosky/types';
import {
  isUsageSpaceFilterActive,
  selectFilterState,
} from '@immosky/object-search-filter';

@Component({
  selector: 'lib-usage-space-filter',
  templateUrl: './usage-space-filter.component.html',
  styleUrls: ['./usage-space-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsageSpaceFilterComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  options: RangeSliderOption[] = [];
  currentFilter!: UsageSpaceRange;
  usageSpaceFilterState!: UsageSpaceFilterState;

  contractType!: ContractType;

  @Output()
  update = new EventEmitter<UsageSpaceRange>();

  get canReset(): boolean {
    return isUsageSpaceFilterActive(
      this.currentFilter,
      this.usageSpaceFilterState.default
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    const subscription = this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.usageSpaceFilterState = filterState.usageSpace;
        this.currentFilter = {
          ...this.usageSpaceFilterState.filter,
        };
        this.options = this.usageSpaceFilterState.options;
        this.cdRef.markForCheck();
      });

    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  reset() {
    this.currentFilter.min = this.options[0];
    this.currentFilter.max = this.options[this.options.length - 1];
    this.emitChange();
  }

  selectMin(option: RangeSliderOption) {
    this.currentFilter.min = option;
    this.emitChange();
  }

  selectMax(option: RangeSliderOption) {
    this.currentFilter.max = option;
    this.emitChange();
  }

  emitChange() {
    this.update.emit(this.currentFilter);
  }
}
